var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3315 39.8902L32.9982 29.2152C32.8092 27.7032 32.0744 26.3123 30.9319 25.304C29.7893 24.2958 28.3178 23.7396 26.794 23.7402H22.2023C20.6793 23.7407 19.2088 24.2972 18.0671 25.3054C16.9254 26.3136 16.1912 27.7039 16.0023 29.2152L14.6669 39.8902C14.5936 40.4767 14.646 41.0721 14.8204 41.6368C14.9949 42.2015 15.2875 42.7226 15.6788 43.1656C16.0701 43.6085 16.5512 43.9632 17.0901 44.2059C17.629 44.4487 18.2134 44.574 18.8044 44.5736H30.1961C30.787 44.5737 31.3711 44.4482 31.9097 44.2053C32.4484 43.9624 32.9292 43.6077 33.3203 43.1648C33.7114 42.7219 34.0038 42.2009 34.1782 41.6363C34.3525 41.0717 34.4048 40.4765 34.3315 39.8902V39.8902Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15.4062C27.9518 15.4062 30.75 12.608 30.75 9.15625C30.75 5.70447 27.9518 2.90625 24.5 2.90625C21.0482 2.90625 18.25 5.70447 18.25 9.15625C18.25 12.608 21.0482 15.4062 24.5 15.4062Z",
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83366 21.6556C10.1348 21.6556 12.0003 19.7901 12.0003 17.4889C12.0003 15.1877 10.1348 13.3223 7.83366 13.3223C5.53247 13.3223 3.66699 15.1877 3.66699 17.4889C3.66699 19.7901 5.53247 21.6556 7.83366 21.6556Z",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1667 21.6556C43.4679 21.6556 45.3333 19.7901 45.3333 17.4889C45.3333 15.1877 43.4679 13.3223 41.1667 13.3223C38.8655 13.3223 37 15.1877 37 17.4889C37 19.7901 38.8655 21.6556 41.1667 21.6556Z",
    stroke: "white",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1667 27.9063H41.8042C42.7906 27.9061 43.7449 28.2559 44.4976 28.8934C45.2503 29.5308 45.7524 30.4146 45.9146 31.3875L46.6084 35.5542C46.708 36.1511 46.6763 36.7626 46.5155 37.3461C46.3548 37.9296 46.0689 38.4711 45.6777 38.9328C45.2865 39.3946 44.7994 39.7657 44.2503 40.0201C43.7012 40.2746 43.1032 40.4063 42.498 40.4063H34.9167M7.83339 27.9063H7.19589C6.20956 27.9061 5.25517 28.2559 4.50251 28.8934C3.74985 29.5308 3.24772 30.4146 3.08547 31.3875L2.39172 35.5542C2.29217 36.1511 2.32385 36.7626 2.48458 37.3461C2.6453 37.9296 2.93121 38.4711 3.32241 38.9328C3.71361 39.3946 4.20071 39.7657 4.74983 40.0201C5.29896 40.2746 5.89693 40.4063 6.50214 40.4063H14.0834L7.83339 27.9063Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.0022b853393c364992b1b15d3ac39dda.svg";
export { ForwardRef as ReactComponent };